import Shop from '@/shop';
import DataLayer from '@/extensions/data-layer/ecommerce';

document.addEventListener('DOMContentLoaded', function() {
  try {
    const counterSettings = Shop.config.get('counter_settings').counter_settings;
    const dataLayerName = counterSettings.data_layer_name;
    const new_counters_setup = counterSettings.new_counters_setup;

    if (new_counters_setup) {
      new DataLayer(dataLayerName);
    }
  } catch (error) {
    console.warn('DataLayer: Ошибка инициализации', error);
  }
});
